import type { Icon } from '../../../src/lib/types'
export const mdiAlphabetical: Icon = {
  "id": "alphabetical",
  "name": "Alphabetical",
  "path": "M6,11A2,2 0 0,1 8,13V17H4A2,2 0 0,1 2,15V13A2,2 0 0,1 4,11H6M4,13V15H6V13H4M20,13V15H22V17H20A2,2 0 0,1 18,15V13A2,2 0 0,1 20,11H22V13H20M12,7V11H14A2,2 0 0,1 16,13V15A2,2 0 0,1 14,17H12A2,2 0 0,1 10,15V7H12M12,15H14V13H12V15Z",
  "as": [
    "letters",
    "a-b-c",
    "abc"
  ],
  "tags": [
    "Alpha / Numeric"
  ]
}
export default mdiAlphabetical